import React from 'react';
import { Tooltip } from 'antd';

import '../index.scss';

const calcDuration = (start, end, type) => {
  if (type === 'Milestone') {
    return `${0} day`;
  }
  const startDate = new Date(start),
    endDate = new Date(end);
  const diff = endDate - startDate;
  if (isNaN(startDate) || isNaN(endDate) || diff < 0) {
    return 'N/A';
  }

  const durationDays = Math.floor(diff / (1000 * 3600 * 24)) + 1;
  if (durationDays > 1) {
    return `${(Math.floor(diff / (1000 * 3600 * 24)) + 1).toString()} days`;
  }
  return `${1} day`;
};

function GanttDurationCell(props) {
  const { record, tableDataSource } = props;
  const targetLine = tableDataSource.find((x) => x.id === record.id);

  const tooltipContent = (
    <div className="gantt-duration-division">
      <div className="division-header">Duration</div>
      <div className="division-body">
        {calcDuration(
          targetLine[`startDate_${record.id}`],
          targetLine[`endDate_${record.id}`],
          targetLine.type,
        )}
      </div>
    </div>
  );
  return (
    <div className="gantt-duration-cell">
      <Tooltip
        title={tooltipContent}
        placement="bottomLeft"
        overlayClassName="gantt-duration-cell-overlayClassName"
      >
        <span className="appkiticon icon-time-outline" />
      </Tooltip>
    </div>
  );
}

export default GanttDurationCell;
